import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createThemeEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackThemeOpen = (source: PosthogTrackingSource, themeIds: string[]) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OPEN,
      properties: { source, themeIds },
    });

  const trackThemeOverviewDrawerOpen = (
    source: PosthogTrackingSource,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OVERVIEW_DRAWER_OPEN,
      properties: { source, themeIds },
    });

  const trackThemePerformanceWidgetTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_PERFORMANCE_WIDGET_TAB_SELECTED,
      properties: { source, type, themeIds },
    });

  return {
    trackThemeOpen,
    trackThemeOverviewDrawerOpen,
    trackThemePerformanceWidgetTabSelected,
  };
};
